import React from 'react'


const Flash = ({ color, width, height }) => {
  return (

    <svg width={width ||'10'} height={height || '14'} viewBox='0 0 10 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M9.3103 5.39795C9.28486 5.35307 9.24797 5.31573 9.20339 5.28975C9.15881 5.26377 9.10814 5.25008 9.05655 5.25008H5.23571L5.87629 0.355695C5.88316 0.290191 5.86779 0.22428 5.83265 0.168574C5.79751 0.112868 5.74464 0.0706091 5.68257 0.0486004C5.62049 0.0265918 5.55281 0.0261145 5.49043 0.0472454C5.42805 0.0683764 5.37459 0.109886 5.33867 0.165091L0.69213 8.30565C0.664958 8.34985 0.650066 8.40049 0.648989 8.45236C0.647911 8.50422 0.660688 8.55544 0.686001 8.60073C0.711314 8.64601 0.748248 8.68372 0.792994 8.70998C0.837739 8.73623 0.888678 8.75007 0.940557 8.75008H4.7043L4.19665 13.6518C4.19166 13.7171 4.20865 13.7822 4.24491 13.8367C4.28116 13.8912 4.33461 13.932 4.39674 13.9527C4.45887 13.9733 4.52612 13.9725 4.58779 13.9506C4.64945 13.9286 4.70198 13.8866 4.73704 13.8313L9.3068 5.69159C9.3333 5.64733 9.34758 5.59683 9.3482 5.54525C9.34881 5.49366 9.33573 5.44284 9.3103 5.39795Z'
        fill={color || 'white'} />
    </svg>
  )
}


export default Flash



